import { render, staticRenderFns } from "./FocusCompany.vue?vue&type=template&id=6e239800&scoped=true"
import script from "./FocusCompany.vue?vue&type=script&lang=js"
export * from "./FocusCompany.vue?vue&type=script&lang=js"
import style0 from "./FocusCompany.vue?vue&type=style&index=0&id=6e239800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e239800",
  null
  
)

export default component.exports